/**
 * Prefer institution short_name for compact UI labels; fall back to node/site name.
 * Aligns with backend firstNonEmpty(CenterShortName, CenterName, NodeName, NodeID).
 */
export type InstitutionNameSource = {
  center_short_name?: string | null;
  site_name?: string | null;
  center_name?: string | null;
  node_name?: string | null;
  node_id?: string | null;
};

function trimName(value?: string | null): string {
  return (value || '').trim();
}

/** Compact label shown to referrers (and similar roles) across the portal. */
export function institutionDisplayName(source: InstitutionNameSource, fallback = '—'): string {
  const short = trimName(source.center_short_name);
  if (short) return short;

  const nodeName =
    trimName(source.site_name) ||
    trimName(source.center_name) ||
    trimName(source.node_name) ||
    trimName(source.node_id);
  return nodeName || fallback;
}

/** Full / legal name when it differs from the compact display label. */
export function institutionFullName(source: InstitutionNameSource): string {
  return (
    trimName(source.site_name) ||
    trimName(source.center_name) ||
    trimName(source.node_name) ||
    trimName(source.node_id)
  );
}
